import React from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import dayjs from "dayjs";
import { DialogType } from "@fluentui/react";
import StockSearchForm from "../../forms/stockSearchForm";
import StockForm from "../../forms/stockForm";
import StockRateUpdateForm from "../../forms/StockRateUpdateForm";
import { PageHeader } from "../../shared/pageHeader";
import { Modal } from "../../shared/modal";
import {
  getStock,
  updateStock,
  updateStockRate,
  updateStockClient,
} from "../../../store/actions/stockActions";
import { getClientList, getItemList } from "../../../store/actions/metaActions";
import {
  reportClients,
  resetReportClient,
} from "../../../store/actions/reportActions";
import { ClientReport } from "./";
import "./scss/clientReport.scss";
import StockClientUpdateForm from "../../forms/StockClientUpdateForm";

class ClientReportPage extends React.Component {
  state = {
    client: "",
    endDate: dayjs().format("YYYY-MM-DD"),
    formSubmitted: false,
    selectedStocks: [],
    startDate: dayjs().startOf("week").format("YYYY-MM-DD"),
    stockEditModalOpen: false,
    stockRateUpdateModalOpen: false,
    stockClientUpdateModalOpen: false,
  };

  componentDidMount() {
    const { getClientList, getItemList, resetReportClient } = this.props;
    getClientList();
    getItemList();
    resetReportClient();
  }

  componentDidUpdate(prevProps, prevState) {
    const { stocks } = this.props;
    const { startDate, endDate, client, formSubmitted } = this.state;

    if (
      prevState.startDate !== startDate ||
      prevState.endDate !== endDate ||
      prevState.client !== client
    ) {
      this.getClientReport();
    }

    if (this.props.startDate && prevProps.startDate !== this.props.startDate) {
      this.setState({
        startDate: dayjs(this.props.startDate).format("YYYY-MM-DD"),
      });
    }

    if (this.props.endDate && prevProps.endDate !== this.props.endDate) {
      this.setState({
        endDate: dayjs(this.props.endDate).format("YYYY-MM-DD"),
      });
    }

    if (prevProps.client !== this.props.client) {
      this.setState({
        client: this.props.client,
      });
    }

    if (prevProps.stocks.requesting && !stocks.requesting && formSubmitted) {
      this.setState(
        {
          stockEditModalOpen: false,
          formSubmitted: false,
        },
        () => {
          this.getClientReport();
        }
      );
    }
  }

  getClientReport = () => {
    const { startDate, endDate, client } = this.state;
    const { reportClients } = this.props;
    if (client && client.value) {
      this.setState({
        selectedStocks: [],
      });
      reportClients({
        startDate,
        endDate,
        client: (client && client.value) || "",
      });
    }
  };

  onDownload = () => {
    const { startDate, endDate, client } = this.state;
    const { reportClients } = this.props;
    if (client && client.value) {
      reportClients({
        startDate,
        endDate,
        client: (client && client.value) || "",
        type: "excel",
      });
    }
  };

  onPrint = () => {
    window.print();
  };

  onAction = (action, item) => {
    const { getStock } = this.props;
    if (action === "edit") {
      getStock({
        id: item.id,
      });
      this.setState({
        stockEditModalOpen: true,
      });
    }
  };

  onSubmit = (values) => {
    const { updateStock, stocks } = this.props;
    const formPayload = {
      ...values,
      clientId: values.clientId.value,
      entryType: values.entryType.key,
      itemId: (values.itemId && values.itemId.value) || "",
      stockDate: dayjs(values.stockDate).format("YYYY-MM-DD"),
    };
    this.setState(
      {
        formSubmitted: true,
      },
      () => {
        updateStock({
          ...formPayload,
          id: stocks.record.id,
        });
      }
    );
  };

  onRateUpdate = (values) => {
    const { updateStockRate } = this.props;
    const formPayload = {
      stocks: this.state.selectedStocks,
      rate: values.rate,
    };
    this.setState(
      {
        stockRateUpdateModalOpen: false,
        selectedStocks: [],
        formSubmitted: true,
      },
      () => {
        updateStockRate(formPayload);
      }
    );
  };

  onClientUpdate = (values) => {
    const { updateStockClient } = this.props;
    const formPayload = {
      ...values,
      stocks: this.state.selectedStocks,
      clientId: values.clientId.value,
    };
    this.setState(
      {
        stockClientUpdateModalOpen: false,
        selectedStocks: [],
        formSubmitted: true,
      },
      () => {
        updateStockClient(formPayload);
      }
    );
  };

  handleStockSelect = (selectedStock) => {
    this.setState((prevState) => {
      const selectedStocks = [...prevState.selectedStocks];
      const index = selectedStocks.findIndex(
        (stockId) => stockId === selectedStock.id
      );
      if (index > -1) {
        selectedStocks.splice(index, 1);
      } else {
        selectedStocks.push(selectedStock.id);
      }
      return { selectedStocks };
    });
  };

  render() {
    const { session, clientReport } = this.props;
    const { selectedStocks } = this.state;
    const userAccess = session.user.details.access;
    return (
      <>
        <PageHeader
          title="Client Report"
          actions={[]}
          searchComponent={
            <StockSearchForm
              forReport={true}
              onSubmit={this.onTextFormSubmit}
              userAccess={userAccess}
              canDownload={
                clientReport &&
                !clientReport.requesting &&
                clientReport.data &&
                clientReport.data.stocks &&
                clientReport.data.stocks.length
              }
              selectedStocks={selectedStocks}
              onDownload={this.onDownload}
              onPrint={this.onPrint}
              onRateChange={() =>
                this.setState({ stockRateUpdateModalOpen: true })
              }
              onClientChange={() =>
                this.setState({ stockClientUpdateModalOpen: true })
              }
            />
          }
        />
        <ClientReport
          onStockSelect={this.handleStockSelect}
          onAction={this.onAction}
        />
        <Modal
          title="Edit Stock"
          hideModal={!this.state.stockEditModalOpen}
          className="large"
          type={DialogType.close}
          toggleHideModal={() =>
            this.setState({
              stockEditModalOpen: false,
            })
          }
        >
          <StockForm edit={true} onSubmit={this.onSubmit} />
        </Modal>
        <Modal
          title="Update Stock Rate"
          hideModal={!this.state.stockRateUpdateModalOpen}
          className="large"
          type={DialogType.close}
          toggleHideModal={() =>
            this.setState({
              stockRateUpdateModalOpen: false,
            })
          }
        >
          <StockRateUpdateForm edit={true} onSubmit={this.onRateUpdate} />
        </Modal>
        <Modal
          title="Update Stock Client"
          hideModal={!this.state.stockClientUpdateModalOpen}
          className="large"
          type={DialogType.close}
          toggleHideModal={() =>
            this.setState({
              stockClientUpdateModalOpen: false,
            })
          }
        >
          <StockClientUpdateForm edit={true} onSubmit={this.onClientUpdate} />
        </Modal>
      </>
    );
  }
}

const selector = formValueSelector("stockSearchForm");
const mapStateToProps = ({ session, reports, stocks, ...state }) => ({
  session,
  stocks,
  startDate: selector(state, "startDate"),
  endDate: selector(state, "endDate"),
  client: selector(state, "client"),
  clientReport: reports.clientReport,
});

const mapDispatchToProps = () => ({
  getClientList,
  getItemList,
  getStock,
  reportClients,
  resetReportClient,
  updateStock,
  updateStockRate,
  updateStockClient,
});

export default connect(mapStateToProps, mapDispatchToProps())(ClientReportPage);
